export enum ResponseStatus {
  ALL = "All",
  NOT_PASSING = "Not Passing",
  INCOMPLETE = "Incomplete",
  COMPLETE = "Complete",
}
